module.exports = __webpack_public_path__ + "img/logoB.f408b8ea.png";